module.exports = __webpack_public_path__ + "static/media/Subtract06.07edbe10.svg";